import { ReactNode } from "react";

interface InfoItemProps {
  title?: string;
  children?: ReactNode;
  rootClassName?: string;
  titleClassName?: string;
  className?: string;
}

export default function InfoItemTwo({
  title,
  children,
  rootClassName = "",
  titleClassName = "",
  className = "",
}: InfoItemProps) {
  return (
    <div
      className={`flex justify-between items-center border px-3 py-2.5 border-extra-light border-t-0 font-medium  ${rootClassName}`}
    >
      {title ? (
        <h4 className={`text-display-body ${titleClassName}`}>{title}</h4>
      ) : null}
      <div
        className={`text-display-body w-7 h-7 rounded-full border-2 border-solid border-[#B4C4FF] flex justify-center items-center ${className}`}
      >
        {children ?? "N/A"}
        {/* na */}
      </div>
    </div>
  );
}
